export const aboutData = {
    title: "Who I am",
    description1: "My name's Siddharth Bisht. I'm a Full Stack Developer (MERN + React Native), based on Nainital Uttrakhand India, working remotely.",
    description2: "",
    image: 2
}